import { LandingComponentsConfig, LandingScreenSchema } from '@/modules/Landing/instances/@types/landing-types'
import genderSelectionLoaderJson from '@/data/lottie-animations/genderSelectionLoader.json'

const schema: LandingScreenSchema = {
	order: ['LandingHead', 'LandingTitle', 'LandingLottieAnimation', 'LandingProgressLoader', 'LandingFooter'],

	components: {
		// TODO(L10N-2654): hardcoded EN — the funnel is EN-only for now, web.json has no lymphatic keys.
		LandingTitle: (): LandingComponentsConfig['LandingTitle'] => ({
			title: 'Lymphatic Walking Plan<br/>Based on Your Age',
			size: 'small',
		}),

		LandingLottieAnimation: (): LandingComponentsConfig['LandingLottieAnimation'] => ({
			animationData: genderSelectionLoaderJson,
			loop: true,
			customStyles: {
				height: '50vh',
			},
		}),

		// Label and note intentionally omitted — the component's defaults are already the Figma copy.
		LandingProgressLoader: (): LandingComponentsConfig['LandingProgressLoader'] => ({
			duration: 3500,
		}),
	},
}

export default schema
